export default __webpack_public_path__ + "static/media/vr.98a1c996.png";